export default "__VITE_ASSET__1bfbdaa4__"